module.exports = __webpack_public_path__ + "pc/static/img/user_action.05b53459.png";